import axios from 'axios'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 30000, // 建议适当放宽超时
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers['X-Access-Token'] = `${token}`
    }
    // 确保POST请求使用正确的Content-Type
    if (config.method === 'post' || config.method === 'put') {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const data = response.data
    // 根据后端接口文档，success为true表示成功，code为200也表示成功
    if (data.code !== 200 && data.success !== true) {
      console.error('接口错误:', data.message || data.msg || '请求失败')
      return Promise.reject(data)
    }
    return data
  },
  error => {
    if (error.response) {
      const { status } = error.response
      if (status === 401) {
        localStorage.removeItem('token')
        router.replace('/login')
      } else if (status === 403) {
        console.error('无权限访问')
      } else if (status >= 500) {
        console.error('服务器异常')
      }
    }
    return Promise.reject(error)
  }
)

export default service
